import Card, { CardGrid } from "../components/Card";
import StatTable from "../components/StatTable";
import StatsGate from "../components/StatsGate";
import { Games, TabProps } from "../types";
import { useStats } from "../useStats";

const when = (v: string | null) => (v ? new Date(v).toLocaleString() : "n/a");

export default function GamesTab({ query, reloadKey, onOpenGame }: TabProps & {
  onOpenGame: (tenant: string, gameId: string) => void;
}) {
  const state = useStats<Games>("/games", query, reloadKey);
  return (
    <StatsGate state={state}>
      {(data) => (
        <CardGrid>
          <Card title="Games by engagement (click a game for its timeline)" wide>
            <StatTable
              rows={data.games} getRowId={(r) => `${r.tenant}:${r.gameId}`}
              onRowClick={(r) => onOpenGame(r.tenant, r.gameId)}
              columns={[
                { field: "tenant", headerName: "Tenant", flex: 1 },
                { field: "gameId", headerName: "Game", flex: 1 },
                { field: "messages", headerName: "Messages", type: "number", flex: 1 },
                { field: "quickReactions", headerName: "Quick reactions", type: "number", flex: 1 },
                { field: "messageReactions", headerName: "Message reactions", type: "number", flex: 1 },
                { field: "uniqueFans", headerName: "Fans who chatted or reacted", type: "number", flex: 1 },
                { field: "watchParties", headerName: "Parties", type: "number", flex: 1 },
                { field: "moments", headerName: "Fan clips", type: "number", flex: 1 },
                { field: "firstActivityAt", headerName: "First activity", flex: 1.5, valueFormatter: (v: string | null) => when(v) },
                { field: "lastActivityAt", headerName: "Last activity", flex: 1.5, valueFormatter: (v: string | null) => when(v) },
              ]}
            />
          </Card>
        </CardGrid>
      )}
    </StatsGate>
  );
}
